module.exports = __webpack_public_path__ + "static/media/maslinico-logo.474f98be.svg";